// extracted by mini-css-extract-plugin
export default {"list":"MH4EBLf","list__animate":"ZH58j09","carouselLink":"e0IIGDV TYb4J9A"};